<div class="promo-banner">
  <div class="promo-banner__image">
    <img [src]="getUrl(banner.image.url)" class="promo-banner-image" />
    <button mat-mini-fab class="promo-banner__close-button" (click)="onCloseBanner()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="promo-banner__content">
    <h1 class="promo-banner__title">{{ banner.title }}</h1>

    <p class="promo-banner__description">
      {{ banner.description }}
    </p>
  </div>

  <mat-form-field
    *ngIf="banner.promoCode"
    appearance="outline"
    class="promo-banner__promocode text-field-control text-field-control_bg_white">
    <input
      matInput
      class="text-field-control__input"
      [readonly]="true"
      [formControl]="promoCodeFormControl" />

    <button mat-icon-button matSuffix (click)="onCopyPromoCode()">
      <mat-icon>content_copy</mat-icon>
    </button>
  </mat-form-field>

  <div class="promo-banner__actions">
    <app-mui-button
      *ngIf="banner"
      variant="text"
      color="primary"
      size="large"
      (click)="onDoNotShowAgain()">
      Don't show again
    </app-mui-button>

    <app-mui-button
      *ngIf="banner"
      variant="contained"
      color="primary"
      size="large"
      (click)="onOpenActionUrl()">
      {{ banner.action.title }}
    </app-mui-button>
  </div>
</div>
